// extracted by mini-css-extract-plugin
module.exports = {"content":"TermsAndConditionsPage_content__t4Any"};